import React from 'react'

import { Icon, StandardButton, Txt } from 'src/components/atoms'

import { useAuthority } from 'src/hooks'

type Props = {
  onClickAddUser?: () => void
  isHiddenAddUserButton?: boolean
  className?: string
}

export function NoAssignedUserNotice({ onClickAddUser, isHiddenAddUserButton, className }: Props) {
  const { canAssignProject } = useAuthority()

  return (
    <div className={className}>
      <div className="tw-grid tw-gap-s2 tw-place-items-center">
        <div className="tw-text-standardText-secondary tw-grid tw-gap-r-1 tw-place-items-center">
          <Icon path="search/soft/line" size="--r2" />
          <Txt className="tw-font-bold">ユーザーが存在しません</Txt>
        </div>

        {canAssignProject && !isHiddenAddUserButton && (
          <StandardButton
            buttonType="secondary"
            text="ユーザー追加"
            prependIconPath="plus/soft/line"
            onClick={onClickAddUser}
          />
        )}
      </div>
    </div>
  )
}
